var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71263 21.9622C2.01591 20.7909 1.98837 19.3765 2.63917 18.1791L8.98335 6.5H12.7525L16.2911 12.965L18.1911 11.925L15.2218 6.5H16.2592V4.33343H15.2701L17.3421 0H4.34215L6.60321 4.33343H5.42543V6.5H6.51671L0.734459 17.1444C-0.284248 19.0207 -0.241 21.2356 0.850281 23.0701C1.94156 24.9046 3.8676 26 6.00188 26H8.64714V23.8334H6.00188C4.63926 23.8331 3.40934 23.1341 2.71263 21.9622ZM7.91666 2.16686H13.9045L12.8683 4.33343H9.04734L7.91666 2.16686Z",
    fill: "#89B03C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.842 19.4792V14.0625H10.8423V17.3124H8.67578V22.7291H10.8423V25.9789H23.842V20.5625H21.6755V19.4792H23.842ZM21.6755 16.2291V17.3124H20.5922V16.2291H21.6755ZM13.0089 16.2291H18.4256V17.3124H13.0089V16.2291ZM10.8423 19.4792H16.2591V20.5625H10.8423V19.4792ZM13.0089 23.8124V22.7291H18.4253V23.8124H13.0089ZM21.6755 23.8124H20.5922V22.7291H21.6755V23.8124ZM18.4256 20.5625V19.4792H19.5089V20.5625H18.4256Z",
    fill: "#89B03C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAllIcon);
export default __webpack_public_path__ + "static/media/checkAllIcon.a460bf68bdfcb572d17599b741fe8e58.svg";
export { ForwardRef as ReactComponent };